// export const baseUrl = 'http://localhost:5000';
export const baseUrl = 'https://db.buzoo.org';
// export const baseUrl = process.env.REACT_APP_API_URL;